import { defineComponent as _defineComponent } from 'vue'
import type Vue from "vue";
import {onMounted, ref, watch} from "vue";
import {VERSION} from '@/version';
import {mdiClose, mdiDelete, mdiDotsVertical} from "@mdi/js";
import {appBarPromiseResolverWhichShouldBeUsedInAppVue} from "@/app-bar-promise";
import {strings} from "@/strings/strings";
import {pipingServerUrl} from "@/states/pipingServerUrl";
import {pipingServerUrlHistory} from "@/states/pipingServerUrlHistory";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

/* eslint-disable */
const PipingUI = () => import('@/components/PipingUI.vue');
const MenuContent = () => import('@/components/MenuContent.vue');
const Licenses = () => import("@/components/Licenses.vue");


const appBarRef = ref<Vue>();
const licenseDialog = ref(false);
// NOTE: Clearing input makes inputtingPipingServerUrl null
const pipingServerUrlWithoutProtocol = ref<string | null>(pipingServerUrl.value);
removeHttpsFromPipingServerUrl();
const latestPipingServerUrlWithoutProtocol = ref(pipingServerUrlWithoutProtocol.value);
watch(pipingServerUrlWithoutProtocol, () => {
  latestPipingServerUrlWithoutProtocol.value = pipingServerUrlWithoutProtocol.value;
});
const pipingServerUrlClearable = ref(false);
watch(latestPipingServerUrlWithoutProtocol, () => {
  pipingServerUrl.value = attachHttpsToUrlIfNeed(latestPipingServerUrlWithoutProtocol.value);
});

function setLatestPipingServerUrlWithoutProtocol(event: any) {
  if (typeof event.target.value !== "string") {
    throw new Error("event.target.value is not string");
  }
  latestPipingServerUrlWithoutProtocol.value = event.target.value;
}

function removeHttpsFromPipingServerUrl() {
  const url = pipingServerUrlWithoutProtocol.value;
  if (url === null) {
    return;
  }
  pipingServerUrlWithoutProtocol.value = url.replace(/^https:\/\//, "");
}

function deleteServerUrl(url: string): void {
  // Remove path
  pipingServerUrlHistory.value = pipingServerUrlHistory.value.filter(u => u !== url);
}
function attachHttpsToUrlIfNeed(url: string | null) {
  url = url ?? "";
  return (url.startsWith("http://") || url === "") ? url : `https://${url}`;
}

onMounted(() => {
  // Resolve app bar element
  appBarPromiseResolverWhichShouldBeUsedInAppVue(appBarRef.value!.$el);
});

return { __sfc: true,PipingUI, MenuContent, Licenses, appBarRef, licenseDialog, pipingServerUrlWithoutProtocol, latestPipingServerUrlWithoutProtocol, pipingServerUrlClearable, setLatestPipingServerUrlWithoutProtocol, removeHttpsFromPipingServerUrl, deleteServerUrl, attachHttpsToUrlIfNeed, VERSION, mdiClose, mdiDelete, mdiDotsVertical, strings, pipingServerUrlHistory }
}

})